// extracted by mini-css-extract-plugin
module.exports = {"Button":"Button_Button__1itR-","Success":"Button_Success__1zH2B","Danger":"Button_Danger__3AbGG"};